import PageShowContainer from './page_show_container';

const PageShow = PageShowContainer;

export default PageShow;
